  function swapImage(option, clickedButton) {

    const buttons = document.querySelectorAll('.image-btn');

    const image = document.getElementById('drinkImage');
    const source = document.getElementById('drinkSource');
    const status = document.getElementById('compareStatus');

    if (option === 'latte') {
      image.src = 'https://cdn.shopify.com/s/files/1/0864/3434/9362/files/section-latte-tab-26.png?v=1772485467';
      source.srcset = 'https://cdn.shopify.com/s/files/1/0864/3434/9362/files/CoffeePLUS_Latte_Vertrical-Tab_01.jpg?v=1773343332';
      image.alt = 'Latte nutritional comparison';
      if (status) status.textContent = 'Showing Latte';
    } else if (option === 'coldbrew') {
      image.src = 'https://cdn.shopify.com/s/files/1/0864/3434/9362/files/CoffeePLUS_ColdBrew-Tab_03.jpg?v=1772478221';
      source.srcset = 'https://cdn.shopify.com/s/files/1/0864/3434/9362/files/CoffeePLUS_ColdBrew_Vertrical-Tab_01.jpg?v=1773343332';
      image.alt = 'Cold Brew nutritional comparison';
      if (status) status.textContent = 'Showing Cold Brew';
    }


    // Update button states. Prefer the passed element; fall back to the
    // current event target so this works regardless of how it's invoked.
    const activeButton = clickedButton || (typeof event !== 'undefined' && event ? event.target : null);

    buttons.forEach(btn => {
      const isActive = btn === activeButton;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }
  
  







